// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"tY-z","subtitle":"uY-z","wrapper":"vY-z","leftArrow":"wY-z","rightArrow":"xY-z"};